module.exports = __webpack_public_path__ + "static/media/CompetitionMathIcon.ba5daad0.svg";